import React from 'react'
import { Form, Switch } from 'antd'
import { useAssignmentAccess } from '../../../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../../../constants/assignment-permissions'

const TestIgnoreCase = () => {
    const hasEditingPermission = useAssignmentAccess([AssignmentPermissions.CAN_EDIT])

    return (
        <Form.Item name='ignoreCase' label='Ignore case' valuePropName='checked' initialValue={false}>
            <Switch aria-label='Ignore case' disabled={!hasEditingPermission} />
        </Form.Item>
    )
}

export default TestIgnoreCase
